import { render, staticRenderFns } from "./entete_piedpage.vue?vue&type=template&id=672e3d04&scoped=true&"
import script from "./entete_piedpage.vue?vue&type=script&lang=js&"
export * from "./entete_piedpage.vue?vue&type=script&lang=js&"
import style0 from "./entete_piedpage.vue?vue&type=style&index=0&id=672e3d04&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672e3d04",
  null
  
)

export default component.exports